import React, { memo } from 'react'

import PanelItem from './PanelItem'

const PageBody = ({ handleEditPanel, data = [] }) => {
  return (
    <div className="page_body_container">
      <div className="panel_manager_body_wrap">
        {data.map((panel) => (
          <PanelItem
            key={panel.id}
            data={panel}
            handleClick={handleEditPanel(panel.id)}
          />
        ))}
      </div>
    </div>
  )
}

export default memo(PageBody)
